import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectProductSettings = () => createSelector(substate, (contextState) => contextState.productSettings);
